export default __webpack_public_path__ + "images/ASSALAAM.ce30bb1.png";